<template>
    <div class="about-container">
        <component v-show="TabbedbarFeatureFlagValue !== null" :is="TabbedbarFeatureFlagValue ? 'NavigationTabbedBar' : 'NavigationTabToolbar'">
            <template v-slot:main-group>
                <NavigationTab :route="routeNames.AboutSystemInformationRoute" icon="/icons/about/system_info_icon.svg" :title="TabbedbarFeatureFlagValue ? '' : localizer.Localize('About_System_Information')" :tabName="TabbedbarFeatureFlagValue ? localizer.Localize('About_System_Information') : null"/>
            </template>
        </component>
        <div class="bg">
            <router-view></router-view>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RouteNames from '../../routing/RouteNames';
import { Localizer } from '@/api/Localizer';
import NavigationTab from '../helpers/NavigationTab.vue';
import NavigationTabToolbar from '../helpers/NavigationTabToolbar.vue';
import NavigationTabbedBar from '../helpers/NavigationTabbedBar.vue';
export default defineComponent({
    components: {
        NavigationTab, NavigationTabToolbar, NavigationTabbedBar
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
            routeNames: RouteNames
        }
    },
    computed: {
        TabbedbarFeatureFlagValue(): boolean | null {
            return this.$store.state.security.TabbedbarFeatureFlagValue;
        }
    }
})
</script>

<style scoped>
.about-container {
    width: calc(100% - 24px);
    height: calc(100% - 10px);
    display: grid;
    position: absolute;
    grid-template-rows: auto 1fr;
    box-shadow: 0px 2px 10px 3px var(--sidebar-foreground-12);
    margin: 0 12px;
    padding-bottom: 10px;
    border: 1px solid var(--thin-border)
}

.bg {
    grid-row: 2;
    width: 100%;
    height: 100%;
    position: absolute;
    overflow-y: auto;
    padding-bottom: 16px;
}
</style>
